export default __webpack_public_path__ + "static/soc2-9a376392bf69fb9ff8ad8bff7034fe28.svg";